import { MouseEvent } from 'react';

import { styled } from '@mui/material';

import {
  IconButton,
  Icons,
  mergeSx,
  SxProps,
  tokens,
} from '@cast/design-system';
import { downloadFile } from '@cast/utils';

type DownloadProps = {
  text: string;
  filename?: string;
  testId?: string;
  onDownload?: (text: string) => void;
  sx?: SxProps;
};

const DownloadIcon = styled(Icons.DownloadSimple)({
  fill: 'currentColor',
  strokeWidth: 2.5,
});

export const Download = ({
  text,
  filename = 'code.txt',
  testId = 'download',
  onDownload,
  sx,
}: DownloadProps) => {
  const handleDownload = (e: MouseEvent) => {
    e.stopPropagation();
    downloadFile(text, filename);
    onDownload?.(text);
  };

  return (
    <IconButton
      testId={testId}
      onClick={handleDownload}
      size="sm"
      sx={mergeSx(
        {
          color: tokens.theme.fg.structural.secondary,
          width: 'unset',
          height: 'unset',
        },
        sx
      )}
    >
      <DownloadIcon />
    </IconButton>
  );
};
